import { axios } from "@LIBS";
import { Constants } from "@CONFIG";
const ReceiverEndpoints = {
  listReceivers: "api/receivers/list-receivers",
};
const createReceiver = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/receivers`,
    method: "POST",
    data: values,
  });

  return response;
};
const updateReceiver = async (values, id) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/receivers/${id}`,
    method: "PUT",
    data: values,
  });

  return response;
};
const deleteReceiver = async (id) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/receivers/${id}`,
    method: "DELETE",
  });

  return response;
};
const deleteSelectedReceivers = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/receivers/deleteSelectedReceivers`,
    method: "PUT",
    data: values,
  });

  return response;
};
const deleteAllReceivers = async () => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/receivers/deleteAllReceivers`,
    method: "PUT",
  });

  return response;
};
const getAllReceivers = async () => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/receivers/get-all-receivers`,
    method: "GET",
  });

  return response;
};

export {
  createReceiver,
  ReceiverEndpoints,
  deleteReceiver,
  updateReceiver,
  getAllReceivers,
  deleteSelectedReceivers,
  deleteAllReceivers,
};
